import { useEffect } from "react";

export const SuspenseLoader = ({ show }) => {
  return (
    <div
      id="preloader"
      className={show ? "" : "fade-out"}
      style={{ display: show ? "" : "none" }}
    >
      <div id="loader"></div>
    </div>
  );
};
